export default "__VITE_ASSET__Ct0qFHHx__"